import { render, staticRenderFns } from "./idealdetail.vue?vue&type=template&id=5ac64df7&scoped=true"
import script from "./idealdetail.vue?vue&type=script&lang=js"
export * from "./idealdetail.vue?vue&type=script&lang=js"
import style0 from "./idealdetail.vue?vue&type=style&index=0&id=5ac64df7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac64df7",
  null
  
)

export default component.exports